import { Button } from "@progress/kendo-react-buttons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lab } from "../../models/lab";
import LabInvite from "../../pages/labInvites/Lab_Invite";
import ManageLab from "../../pages/labs/Lab_Manage";
import { SettingsNavigation } from "../settings/SettingsNavigation";
import { OnboardingLanding, OnboardingThanks } from "./Onboarding_Landing";
import { useNotificationAPI } from "../NotificationProvider";

const Tabs = ['Onboarding', 'Contact Info', 'Create Lab', 'Add Users', 'Thank You', 'Go to the Home Page']
const StartTab = 0;
const ContactInfoTab = 1;
const CreateLabTab = 2;
const AddUsersTab = 3;
const ThankYouTab = 4;

export const OnboardingMain = () => {
    const [lab, setLab] = useState({} as Lab);
    const [selectedTab, setSelectedTab] = useState(0);
    const { addNotification } = useNotificationAPI();
    const navigate = useNavigate();

    const displayHelperText = () => {
        if (selectedTab === StartTab) {
            return <></>;
        } else if (selectedTab === ContactInfoTab) {
            return <>To create a lab, click the "next" button below.</>;
        } else if (selectedTab === CreateLabTab) {
            return <>Once the lab has been created, click the "next" button below to invite users to join.</>;
        } else if (selectedTab === AddUsersTab) {
            return <>If all users have been invited. Click "next" button below to complete the onboarding process.</>;
        } else if (selectedTab === ThankYouTab) {
            return <></>;
        }

        return <>Error</>;
    }

    const handleBackClick = () => {
        setSelectedTab(selectedTab - 1)
    };

    const handleNextClick = () => {
        if (checkForLabCreationBeforeContinue()) {
            addNotification("Please click 'Create Lab' before continuing", "Onboarding", "info");
        } else {
            setSelectedTab(selectedTab + 1)
        }
    };

    const content = () => {
        if (selectedTab === StartTab) {
            return <OnboardingLanding></OnboardingLanding>;
        } else if (selectedTab === ContactInfoTab) {
            return <SettingsNavigation></SettingsNavigation>;
        } else if (selectedTab === CreateLabTab) {
            return <ManageLab setLab={setLab} isPopup={true} hideTabs={true}></ManageLab>;
        } else if (selectedTab === AddUsersTab) {
            return <LabInvite labId={lab.Id} facilityName={lab.FacilityName}></LabInvite>;
        } else if (selectedTab === ThankYouTab) {
            return <OnboardingThanks></OnboardingThanks>;
        }

        return <>Error</>;
    }

    const checkForLabCreationBeforeContinue = () => {
        return selectedTab === CreateLabTab && !(lab?.Id > 0);
    }

    return <div style={{ maxWidth: "1000px" }}>
        <h1>{Tabs[selectedTab]}</h1><br />

        {content()}<br />

        <div>
            {displayHelperText()}
        </div>
        <br></br>
        <div style={{ width: "80%", marginLeft: "10%" }}>
            {selectedTab !== StartTab && <Button className="user-button k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleBackClick}>
                Back: {Tabs[selectedTab - 1]}
            </Button>}
            {selectedTab === ThankYouTab ?
                <Button style={{ float: "right" }} className="user-button k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => { navigate('/home'); }}>
                    Next: {Tabs[selectedTab + 1]}
                </Button> :
                <Button hidden={true} style={{ float: "right" }} className="user-button k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleNextClick}>
                    Next: {Tabs[selectedTab + 1]}
                </Button>}
        </div>
    </div>;
}